import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, input, untracked } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

import { MapComponent } from '../map/map.component';
import { OrderStore } from '../order-store';
import { TimelineComponent } from '../timeline/timeline.component';

@Component({
  selector: 'customer-tracking-details',
  imports: [DatePipe, MatIcon, TimelineComponent, MatButton],
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailsComponent {
  private readonly dialog = inject(MatDialog);
  public readonly legStopId = input<string>();
  public readonly orderId = input.required<string>();
  protected readonly store = inject(OrderStore);

  constructor() {
    effect(() => this.store.requestOrder(this.orderId(), untracked(this.legStopId)));
  }

  public openMap(currentPosition: google.maps.LatLngLiteral, destination: google.maps.LatLngLiteral): void {
    this.dialog.open(MapComponent, {
      width: '60vw',
      data: { currentPosition, destination }
    });
  }
}
